export const BaseWebsocketBatchedMessagesType = 'batched-messages' as const;

export type BaseWebsocketBatchedMessages<Message> = {
  type: typeof BaseWebsocketBatchedMessagesType;
  messages: Message[];
};

export const isBaseWebsocketBatchedMessages = <Message>(
  message: unknown,
): message is BaseWebsocketBatchedMessages<Message> => {
  if (typeof message !== 'object' || message === null) {
    return false;
  }

  if (!('type' in message) || typeof message.type !== 'string') {
    return false;
  }

  if (message.type !== BaseWebsocketBatchedMessagesType) {
    return false;
  }

  if (!('messages' in message) || !Array.isArray(message.messages)) {
    return false;
  }

  return true;
};
